import React from "react";
import { formatContactType, formatDateTime } from "./formatters.js";

export default function CrmDeletedContactDrawer({
  contact,
  open,
  onClose,
  onRestore,
  restoring,
  error
}) {
  if (!open || !contact) return null;

  const listingCount = contact.listingsOwned?.length || 0;
  const tags = Array.isArray(contact.tags) ? contact.tags : [];

  return (
    <div className="fixed inset-0 z-[110] flex">
      <div className="flex-1" onClick={onClose} aria-hidden />
      <div className="w-[420px] max-w-full overflow-y-auto bg-slate-950/95 border-l border-white/10 p-6 shadow-2xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-slate-500">Deleted contact</p>
            <div className="mt-1 flex items-center gap-2">
              <h2 className="text-2xl font-semibold text-white">{contact.name || "Unnamed"}</h2>
              <span className="rounded-full border border-rose-500/40 bg-rose-500/10 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-rose-200">
                Deleted
              </span>
            </div>
          </div>
          <button onClick={onClose} className="text-white/60 hover:text-white">
            Close
          </button>
        </div>
        <div className="mt-5 space-y-4">
          <div className="text-sm text-slate-300">
            <div>Type: {formatContactType(contact.type)}</div>
            <div>About: {contact.role || "—"} at {contact.company || "—"}</div>
            <div className="text-xs text-slate-500">Deleted {formatDateTime(contact.deletedAt)}</div>
          </div>
          <div className="space-y-2">
            <div className="text-xs uppercase tracking-[0.35em] text-slate-400">Primary email</div>
            <p className="text-sm text-white">{contact.emails?.[0] || "—"}</p>
            <div className="text-xs uppercase tracking-[0.35em] text-slate-400">Phone</div>
            <p className="text-sm text-white">{contact.phones?.[0] || "—"}</p>
          </div>
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2 text-[11px] uppercase tracking-[0.3em] text-slate-200">
              {tags.map((tag) => (
                <span key={tag} className="rounded-full border border-white/10 bg-white/5 px-3 py-1">
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className="rounded-2xl border border-white/10 bg-black/30 p-3 text-sm text-slate-200">
            <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Notes</p>
            <p>{contact.notes || "No notes recorded."}</p>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs uppercase tracking-[0.35em] text-slate-400">
              <span>Associated listings</span>
              <span>{listingCount}</span>
            </div>
            <div className="space-y-2">
              {contact.listingsOwned?.map((listing) => (
                <div
                  key={listing.id}
                  className="rounded-2xl border border-white/10 bg-white/5 px-3 py-2 text-xs text-white/80"
                >
                  <div className="font-semibold text-white">{listing.refCode || listing.id}</div>
                  <div className="text-[11px] text-slate-400">{listing.status || "Listing"}</div>
                </div>
              ))}
              {!listingCount && (
                <div className="rounded-2xl border border-dashed border-white/10 bg-white/5 px-3 py-2 text-xs text-slate-400">
                  No listings were linked to this contact.
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {error && (
              <div className="rounded-2xl border border-rose-500/40 bg-rose-500/10 px-3 py-2 text-sm text-rose-200">
                {error}
              </div>
            )}
            <button
              type="button"
              onClick={() => onRestore(contact.id)}
              disabled={restoring}
              className="rounded-2xl border border-emerald-400/40 bg-emerald-500/80 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-500 transition disabled:cursor-not-allowed disabled:opacity-70"
            >
              {restoring ? "Restoring…" : "Restore contact"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
